import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Chip } from "@mui/material";
import moment from "moment";

const actionColor = {
  create: "success",
  update: "warning",
  delete: "error",
};

const InvoiceHistoryModal = ({ open, onClose, history, isLoading }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative z-10 bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[85vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <HistoryIcon sx={{ color: "#1976d2" }} />
            <h2 className="text-lg font-bold text-gray-800">Invoice History</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto flex-1 px-6 py-4">
          {isLoading ? (
            <div className="flex justify-center items-center py-12">
              <CircularProgress size={32} />
            </div>
          ) : !history || history.length === 0 ? (
            <p className="text-center text-gray-500 py-12 text-sm">
              No history records found for this invoice.
            </p>
          ) : (
            <ol className="relative border-l border-gray-200 ml-3">
              {history.map((log, index) => (
                <li key={log._id?.$oid || log._id || index} className="mb-6 ml-6">
                  <span className="absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 ring-4 ring-white">
                    <HistoryIcon sx={{ fontSize: 14, color: "#1976d2" }} />
                  </span>

                  <div className="rounded-lg border border-gray-100 bg-gray-50 p-4 shadow-sm">
                    <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                      <Chip
                        label={log.action?.toUpperCase() || "—"}
                        color={actionColor[log.action?.toLowerCase()] ?? "default"}
                        size="small"
                      />
                      <time className="text-xs text-gray-500">
                        {log.createdAt?.$date
                          ? moment(log.createdAt.$date).format("LLLL")
                          : log.createdAt
                          ? moment(log.createdAt).format("LLLL")
                          : "—"}
                      </time>
                    </div>

                    <div className="text-sm text-gray-700 space-y-1">
                      <div>
                        <span className="font-bold text-gray-700">Performed By: </span>
                        {log.performedBy?.email || "—"}
                        {log.performedBy?.role && (
                          <span className="ml-2 text-xs text-gray-400">
                            ({log.performedBy.role})
                          </span>
                        )}
                      </div>
                      <div>
                        <span className="font-bold text-gray-700">IP Address: </span>
                        {log.ipAddress || "—"}
                      </div>
                      <div className="flex items-center gap-1 min-w-0">
                        <span className="font-bold text-gray-700 shrink-0">User Agent: </span>
                        <span
                          className="truncate ml-1"
                          title={log.userAgent || "—"}
                        >
                          {log.userAgent || "—"}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold text-gray-700">Module: </span>
                        {log.module || "—"}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceHistoryModal;
